export default { sha: 'f87d0ff7654894d8bff75e78640e66111d1928d2', buildNumber: 'undefined' }
